let axiosConfig = {
    baseURL: 'https://byh-api.dr-gobroad.com',

    // 响应时间
    timeout: 6000,
    // 配置cookie
    withCredentials: false,
    // 配置请求头
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
    },
    maxContentLength: 5000
}
export default axiosConfig;



// WEBPACK FOOTER //
// ./src/util/axios-config.js